import BaseCustomScheme from './baseCustomScheme'

export default class SchemeBasic extends BaseCustomScheme {
  // you can extend functionality of this schema later
}
